import React, { useEffect, useState } from 'react'
import { config } from './config'
import './styles.scss'
import { EasyChart } from 'components/EasyChart'

let months = [
  'Jan.',
  'Feb.',
  'März',
  'Apr',
  'Mai',
  'Jun.',
  'Jul.',
  'Aug.',
  'Sep.',
  'Okt.',
  'Nov.',
  'Dez.'
]
export const HistoricalChart: React.FC<BaseChartProps> = ({
  nextChange,
  isEmbeded = false
}) => {
  const [drawData, setDrawData] = useState<EasyChartDrawData>()
  useEffect(() => {
    fetch('data-ch.json')
      .then(response => {
        return response.json()
      })
      .then(data => {
        let youCu: number[] = []
        let oldCurve: number[] = []
        let youExp: [number, number][] = []
        let oldExpected: [number, number][] = []
        data['0-64'].forEach((d: InputDataElement) => youCu.push(d.tF))
        data['65+'].forEach((d: InputDataElement) => oldCurve.push(d.tF))
        data['0-64'].forEach((d: InputDataElement) => youExp.push([d.oG, d.uG]))

        data['65+'].forEach((d: InputDataElement) =>
          oldExpected.push([d.oG, d.uG])
        )
        let yearTicks = []
        for (let i = 0; i < Math.round(data['65+'].length / 52) + 1; i++) {
          yearTicks.push(i * 52)
        }
        let monthTicks = []
        for (let i = 0; i < Math.round(data['65+'].length / 4) + 1; i++) {
          monthTicks.push(i * 4)
        }
        let yTicks = [0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000]
        let yearvalues: number[] | [number, number][] = []
        for (let i = 0; i < Math.round(data['65+'].length / 4) + 1; i++) {
          let v: [number, number] = [26 + i * 52, 2015 + i]
          yearvalues.push(v)
        }

        let lastEntry = data['65+'].reverse().find(f => f.tF !== null)
        let lastId =
          data['65+'].length - data['65+'].findIndex(f => f.tF !== null)
        let lastDate = lastEntry._d.split('.')

        let annotations = [
          {
            text: 'Starke##Grippewelle',
            dir: 'horizontal',
            pos: [8, 1500],
            offset: [15, 0]
          },
          {
            text: 'Starke##Grippewelle',
            dir: 'horizontal',
            pos: [108, 1500],
            offset: [15, 0]
          },
          {
            text: 'Hitzesommer',
            dir: 'vertical',
            pos: [27, 1180],
            offset: [0, -25]
          },
          {
            text:
              'obere und untere##Grenze des statistisch##zu erwartenden Wertes',
            dir: 'vertical',
            pos: [6, 1200],
            offset: [0, 100]
          },
          {
            text: 'Altersgruppe##65 Jahre##und älter',
            dir: 'horizontal',
            pos: [186, config.isMobile ? 800 : 1400],
            align: 'middle',
            className: 'bold'
          },
          {
            text: 'Altersgruppe##0 – 64 Jahre',
            dir: 'horizontal',
            pos: [186, 350],
            align: 'middle',
            className: 'bold'
          },
          {
            text: 'Covid-19-Pandemie',
            dir: 'horizontal',
            pos: [270, 1720],
            align: config.isMobile ? 'end' : 'middle',
            className: 'bold red'
          },
          {
            // text: +lastDate[0] + '. ' + months[ +lastDate[1]-1],
            text: +lastDate[0] + '. ' + +lastDate[1] + '. ',
            dir: 'vertical',
            pos: [config.isMobile ? lastId : lastId - 4, lastEntry.tF + 170],
            className: 'bold red',
            align: config.isMobile ? 'end' : 'middle'
          }
        ]
        setDrawData([
          { type: 'hticks', values: yTicks, className: 'horizontalTicks' },
          {
            type: 'vticks',
            values: config.isMobile ? [] : monthTicks,
            className: 'monthticks'
          },
          { type: 'vticks', values: yearTicks, className: 'yearticks' },
          { type: 'vticks', values: yearvalues, className: 'yearvalues' },
          { type: 'curve', values: youCu, className: 'over' },
          { type: 'curve', values: oldCurve, className: 'over' },
          { type: 'area', values: youExp, className: 'expected' },
          { type: 'area', values: oldExpected, className: 'expected' },
          {
            type: 'curve',
            values: youCu,
            className: 'under',
            clipped: youExp
          },
          {
            type: 'curve',
            values: oldCurve,
            className: 'under',
            clipped: oldExpected
          },
          { type: 'annotations', values: annotations, className: 'annotations' }
        ])
      })
  }, [])
  console.log(drawData)
  return (
    <div className='ui vertical very fitted segment'>
      <div
        className={
          'ui container historicalchart ' + (isEmbeded ? 'embeded' : '')
        }
      >
        <div className='chartHead'>
          <div className='title'>Wöchentliche Todesfälle in der Schweiz</div>
          <div className='sub'>
            Die Statistik des BFS zeigt die Todesfälle in der Schweiz mit einer
            Verzögerung von gut einer Woche.
          </div>
          <div className='key'>
            <div className='entry'>
              <img className='icon' src={require('images/ueb_key-01.svg')} />
              <div className='label'>Sterblichkeit</div>
            </div>
            <div className='entry'>
              <img className='icon' src={require('images/ueb_key-02.svg')} />
              <div className='label'>Über- bzw. Untersterblichkeit</div>
            </div>
            <div className='entry nL'>
              <div className='label'>Anzahl Todesfälle pro Kalenderwoche</div>
            </div>
          </div>
        </div>
        {drawData && <EasyChart data={drawData} y={[0, 2000]} />}
        <div className='source'>
          Quelle: Bundesamt für Statistik – Todesursachenstatistik
        </div>
      </div>
    </div>
  )
}
